import { useContext, ComponentType, PropsWithChildren } from "react";
import { ClientType } from "@app/client/client";
import { UserContext } from "@app/user/UserContext";

export interface ShowSharedInsightsForClientProps {
  showSharedInsightsForClient: boolean;
}

const useShowSharedInsightsForClient = (): boolean => {
  const userContext = useContext(UserContext);

  if (!userContext) {
    return false;
  }

  return userContext.clientType === ClientType.Issuer;
}

export default useShowSharedInsightsForClient;

export function withShowSharedInsightsForClient<T>(Component: ComponentType<PropsWithChildren<T & ShowSharedInsightsForClientProps>>): ComponentType<PropsWithChildren<T>> {
  return function WrappedComponent(props) {
    const enabled = useShowSharedInsightsForClient();
    return <Component {...props} {...{['showSharedInsightsForClient']: enabled}} />;
  }
}
